import React from "react";
import { Action as ReduxAction } from "redux";
import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { LayoutType } from "./constants";

export type LayoutState = {
  type: LayoutType;
};

export const initialLayoutState: LayoutState = {
  type: LayoutType.Default,
};

const actionCreator = actionCreatorFactory();

export const LayoutAction = {
  setType: actionCreator<LayoutType>("SET_LAYOUT_TYPE"),
} as const;
export type LayoutAction = (typeof LayoutAction)[keyof typeof LayoutAction];
export type LayoutActionType = LayoutAction["type"];

const reducer = reducerWithInitialState<LayoutState>(initialLayoutState).case(
  LayoutAction.setType,
  (state, payload) => {
    return {
      ...state,
      type: payload,
    };
  }
);

export type LayoutReducer = typeof reducer;

export type LayoutContext = {
  state: LayoutState;
  dispatch: React.Dispatch<ReduxAction<LayoutActionType>>;
};

export const LayoutContext = React.createContext({} as LayoutContext);

interface Props {
  children?: React.ReactNode;
}

const LayoutProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialLayoutState);
  return (
    <LayoutContext.Provider value={{ state, dispatch }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
